module.exports = __webpack_public_path__ + "static/media/a13.7ba93b73.jpg";